import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import IntakesTable from "../intakes/IntakesTable";
import DocumentEventsConsumer from "../intakes/DocumentEventsConsumer";
import { createPortal } from "react-dom";
import { PortalContext } from "contexts/PortalContext";
import { CaseDetailGroup } from "components/CaseDetailGroup";
import { useParamNumbers } from "helpers/hooks/useParamNumbers";
import { selectCase } from "redux/slices/case";
import { useAppSelector } from "redux/hooks";
import useSearchParamsWithUpdate from "helpers/hooks/useSearchParamsWithUpdate";

const Documents = () => {
  // Route is /lens/:lensId/cases/:caseId/documents
  // Get lensId and caseId from the route with useParams
  const { caseId, lensId } = useParamNumbers(["caseId", "lensId"]);

  const { searchParams } = useSearchParamsWithUpdate();
  const { portalRefElement } = useContext(PortalContext);
  const clientCase = useAppSelector(selectCase);

  const navigate = useNavigate();

  if (lensId === undefined || caseId === undefined) {
    navigate("../");
    return null;
  }

  useEffect(() => {
    const documentId = searchParams.get("documentId");
    if (documentId !== null) {
      navigate(`./${documentId}`);
    }
  }, [searchParams]);

  return (
    <div className="pt-4">
      {portalRefElement && createPortal(<CaseDetailGroup myCase={clientCase} />, portalRefElement)}
      <DocumentEventsConsumer caseId={caseId}>
        <IntakesTable lensId={lensId} caseId={caseId} />
      </DocumentEventsConsumer>
    </div>
  );
};

export default Documents;
